<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<div class="mgb_5">
					<em class="lt_text">Valid Receipt Date</em>
					<span class="mgr_15">
						<CustomDatePicker v-model="from_date" /> ~
						<CustomDatePicker v-model="to_date" />
					</span>

					<em class="lt_text">Receipt Type</em>
					<span class="int_type_no_border mgr_5">
						<label>
							<select v-model="receipt_type" class="tbl_select">
								<option value="" selected> All</option>
								<option v-for="type in receiptTypeList" :value="type.code" :key="type.code">{{ type.name }}</option>
							</select>
						</label>
					</span>

					<span class="int_type_no_border mgr_15">
						<input type="checkbox" class="int_type" v-model="receipt_type_exclude_yn" id="exclude" :disabled="!receipt_type" />
						<label class="lt_text" for="exclude">Exclude</label>
					</span>

					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_15">
						<CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code" />
					</span>

					<span class="int_type_no_border mgr_15">
						<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" />
					</span>

					<span class="int_type_no_border mgr_5">
						<input type="checkbox" class="int_type" v-model="bounced" id="bounced" />
						<label class="lt_text" for="bounced">Bounced</label>
					</span>

					<span v-if="['minkhair', 'newjigu'].includes(company_id)" class="int_type_no_border mgr_15">
						<input type="checkbox" class="int_type" v-model="valid_only" id="valid_only" />
						<label class="lt_text" for="valid_only">Valid Only</label>
					</span>
				</div>

				<div>
					<span class="int_type_no_border mgr_10">
						<label class="lt_text">
							<input type="checkbox" ref="summary_bill_to" class="int_type" @change="changeTable('BILLTO')" />
							<em>Summary(Bill To)</em>
						</label>
					</span>

					<span class="int_type_no_border mgr_15">
						<label class="lt_text">
							<input type="checkbox" ref="summary_date" class="int_type" @change="changeTable('DATE')" />
							<em>Summary(Date)</em>
						</label>
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_15" @click="reset()">Reset</a>
					<span v-if="user.company_id == 'hairplus'">
						<em class="lt_text mgr_15">ACH : {{ this.haiplus_summary.g1 | toCurrency }}</em>
						<em class="lt_text mgr_15">Check : {{ this.haiplus_summary.g3 | toCurrency }}</em>
						<em class="lt_text mgr_15">Credit Card : {{ this.haiplus_summary.g2 | toCurrency }}</em>
						<em class="lt_text mgr_15">UPS (COD) : {{ this.haiplus_summary.g4 | toCurrency }}</em>
					</span>
				</div>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<summaryDateTable v-if="is_date_summary" :date_summary_data="date_summary_data" :grand-total="grandTotal" />
				<summaryBillTable v-else-if="is_summary" :grand-total="bill_to_summary_total_amount" :root="bill_to_summary_data" :sort-key="sort_key" :sort-direction="sort_direction" @sort="sort" />
				<dataTable v-else :grand-total="grandTotal" :root="root" :sort-key="sort_key" :sort-direction="sort_direction" :view-receipt-remark="viewReceiptRemark" @sort="sort" />
			</div>
		</div>

		<div class="bottom_bt_box">
			<div v-if="company_id === 'hairplus' && Array.isArray(receiptTypeList)" class="fl_l" style="width: 92%">
				<div class="table-wrapper" style="overflow-x: auto;">
					<table class="remark-table">
						<tbody>
							<tr>
								<th v-for="(type, index) in receiptTypeList" :key="index">{{ type.code }}({{ type.name }})</th>
								<th>GRAND TOTAL</th>
							</tr>
							<tr>
								<td v-for="(type, index) in receiptTypeList" :key="index" class="al_right">{{ getTotalAmount(type.code) | toCurrency }}</td>
								<td class="al_right">{{ grandTotal | toCurrency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiIndex, apiReceiptType } from '@/api/report/report';
import CodeSelect from '@/components/common/CodeSelect.vue';
import { objectToFormData } from '@/api/util';
import PartnerSelect from '@/components/common/PartnerSelect.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { toDate, today } from '@/utils/date';
import DataTable from '@/views/report/ReceiptType/DataTable.vue';
import SummaryBillTable from '@/views/report/ReceiptType/SummaryBillTable.vue';
import SummaryDateTable from '@/views/report/ReceiptType/SummaryDateTable.vue';
import { billToSummaryData, exportReceiptTypeDataExcel, exportReceiptTypeDateSummaryDataExcel, exportReceiptTypeSummaryDataExcel } from '@/views/report/ReceiptType/ReceiptTypeUtils';

export default {
	data: function() {
		return {
			root: [],
			sales_group_code: '',
			salesGroups: [],
			states: [],
			countries: [],
			country: '',
			state: '',
			bill_to_code: '',
			receiptTypeList: '',
			receipt_type: '',
			sort_key: 'bill_to',
			sort_direction: 'ASC',
			from_date: today(),
			to_date: today(),
			itemIndex: 0,
			bounced: false,
			receipt_type_exclude_yn: false,
			valid_only: true,

			search_param: {},
			is_summary: false,
			excel_data: null,
			summary_excel_data: null,

			is_date_summary: false,
			date_summary_data: [],
			date_summary_excel_data: [],
			bill_to_summary_data: [],
			bill_to_summary_total_amount: 0,

			haiplus_summary: { g1: 0, g2: 0, g3: 0, g4: 0 },
		};
	},
	watch: {
		receipt_type: {
			handler() {
				if (!this.receipt_type) this.receipt_type_exclude_yn = false;
			},
		},
	},
	components: {
		SummaryBillTable,
		SummaryDateTable,
		DataTable,
		CodeSelect,
		PartnerSelect,
		CustomDatePicker,
	},
	methods: {
		getTotalAmount(code) {
			const idx = this.root.findIndex(rt => rt.receipt_type_code === code);
			return idx < 0 ? 0 : this.root[idx].total_amount;
		},
		async selectData() {
			const paramObj = {
				sales_group_code: this.sales_group_code || '',
				receipt_type: this.receipt_type || '',
				bill_to_code: this.bill_to_code || '',
				from_date: this.from_date || '',
				to_date: this.to_date || '',
				sort_key: this.sort_key || '',
				sort_direction: this.sort_direction || '',
				bounced: this.bounced ? 'Y' : 'N',
				receipt_type_exclude_yn: this.receipt_type_exclude_yn ? 'Y' : 'N',
				valid_only: this.valid_only ? 'Y' : 'N',
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiReceiptType(param);
			this.root = data.value;
			this.itemIndex = 0;
			this.search_param = paramObj;
			this.bill_to_summary_data = billToSummaryData(data.value);
			const { bill_to_summary_list, bill_to_summary_total_amount } = billToSummaryData(data.value);
			this.bill_to_summary_data = bill_to_summary_list;
			this.bill_to_summary_total_amount = bill_to_summary_total_amount;
			this.convertData();
			this.makeDateSummaryData();
			this.makeDateSummaryExcelData();

			this.haiplus_summary.g1 = this.root.filter(item => ['ACH', 'PACH'].includes(item.receipt_type_code)).reduce((sum, item) => sum + item.total_amount, 0);
			this.haiplus_summary.g2 = this.root.filter(item => ['PCC', 'U6'].includes(item.receipt_type_code)).reduce((sum, item) => sum + item.total_amount, 0);
			this.haiplus_summary.g3 = this.root.filter(item => ['U3', 'U2'].includes(item.receipt_type_code)).reduce((sum, item) => sum + item.total_amount, 0);
			this.haiplus_summary.g4 = this.root.filter(item => ['UC', 'UPC'].includes(item.receipt_type_code)).reduce((sum, item) => sum + item.total_amount, 0);
		},

		convertData() {
			// 누가 납부했는지 저장하는 컬럼이 없기 때문에 receipt_ar이 참조하는 invoice의 bill_to_code를 납부자로 봄.
			// 데이터베이스 구조상으로는 다른 사람의 Invoice Amt를 대납할 수 있는데, 그럴 경우 한 개의 Receipt에 대하여 납부자가 여러 명일 수 있음.
			// => 현재 여러 Invoice를 묶어서 여러 수단으로 납부하는 경우, 1개의 납입수단으로 n개의 invoice를 결제하는 receipt데이터 set이 insert되고,
			//		최종적으로 결제가 안된 invoice 1개만 남은 경우, 남은 납입수단 n개로 invoice를 결제하는 receipt데이터 set이 insert됨.
			//		1개의 receipt 데이터에 대한 receipt_ar: receipt_item은 1:n 혹은 n:1 만 허용

			this.excel_data = [];
			this.summary_excel_data = [];
			let index = 1;
			if (!Array.isArray(this.root)) return;

			for (const type of this.root) {
				if (!Array.isArray(type.receiptTypeDateList)) continue;

				this.excel_data.push({ receipt_type_code: type.receipt_type_code + ' ' + type.receipt_type_name });
				this.summary_excel_data.push({ receipt_type_code: type.receipt_type_code + ' ' + type.receipt_type_name });

				for (const receipt of type.receiptTypeDateList) {
					if (!Array.isArray(receipt.billList)) continue;

					for (const bill of receipt.billList) {
						bill.summary_list = [];
						if (!Array.isArray(bill.receiptItemList)) continue;

						let prevRi = null;
						for (const ri of bill.receiptItemList) {
							let idx = bill.summary_list.findIndex(s => s.receipt_item_no === ri.receipt_item_no);
							if (idx < 0) {
								bill.summary_list.push({
									index: index,
									receipt_item_no: ri.receipt_item_no,
									receipt_item_amount: ri.receipt_item_amount,
									check_no: ri.check_no,
									post_check_yn: ri.post_check_yn,
									post_check_date: ri.post_check_date,
									bounce_yn: ri.bounce_yn,
									bounce_date: ri.bounce_date,
									bounce_invoice_no: ri.bounce_invoice_no,
								});

								this.summary_excel_data.push({
									index: index,
									receipt_type_code: type.receipt_type_code,
									valid_receipt_date: receipt.valid_receipt_date,
									bill_to_code: bill.bill_to_code,
									bill_to_name: bill.bill_to_name,
									receipt_item_amount: ri.receipt_item_amount || null,
									check_no: ri.check_no,
								});

								index++;
							}

							const obj = {};
							obj.index = ri.index;
							obj.receipt_type_code = type.receipt_type_code;

							obj.invoice_dn = ri.invoice_dn;
							obj.invoice_amount = ri.invoice_amount;
							obj.ar_amount = ri.ar_amount;
							obj.check_no = ri.check_no;
							obj.payment_term_code = ri.payment_term_code;
							obj.payment_term_name = ri.payment_term_name;
							obj.past_due_date = ri.past_due_date;
							obj.receipt_remark = ri.receipt_remark;
							if (this.viewReceiptRemark) {
								if (['ACH', 'PACH'].includes(type.receipt_type_code)) {
									obj.receipt_remark = bill.bank_info || '';
								} else if (['PCC', 'CC', 'U6'].includes(type.receipt_type_code)) {
									obj.receipt_remark = bill.card_info || '';
								}
							}

							if (!prevRi || ri.receipt_item_no !== prevRi.receipt_item_no) {
								obj.valid_receipt_date = receipt.valid_receipt_date;
								obj.sales_group_name = bill.sales_group_name;
								obj.bill_to_code = bill.bill_to_code;
								obj.bill_to_name = bill.bill_to_name;
								obj.bill_address_state = bill.bill_address_state;
								obj.receipt_item_amount = ri.receipt_item_amount || null;
							}

							this.excel_data.push(obj);

							prevRi = ri;
						}
					}
				}
				this.excel_data.push({ index: 'Sub Total', receipt_item_amount: type.total_amount });
				this.summary_excel_data.push({ index: 'Sub Total', receipt_item_amount: type.total_amount });
			}
			this.excel_data.push({
				index: 'Grand Total',
				receipt_item_amount: this.grandTotal,
				invoice_dn: null,
				invoice_amount: null,
				ar_amount: null,
				check_no: null,
				payment_term_code: null,
				past_due_date: null,
				receipt_remark: null,
			});
			this.summary_excel_data.push({ index: 'Grand Total', receipt_item_amount: this.grandTotal, check_no: null });
		},
		makeDateSummaryData() {
			const date_summary = []; // [{ valid_receipt_date: '...', total: ..., type_list: [{ type_code: '...', display: '...', amount: ... }, ...] }, ... ]
			if (!Array.isArray(this.root)) {
				this.date_summary_data = [];
				return;
			}

			for (const type of this.root) {
				if (!Array.isArray(type.receiptTypeDateList)) continue;

				for (const receipt of type.receiptTypeDateList) {
					if (!Array.isArray(receipt.billList)) continue;

					const idx = date_summary.findIndex(el => el.valid_receipt_date === receipt.valid_receipt_date);
					const receipt_item_no_list = []; // 이미 가산된 receipt_item의 금액이 중복으로 가산되는 것을 막기 위함.
					for (const bill of receipt.billList) {
						if (!Array.isArray(bill.receiptItemList)) continue;

						for (const ri of bill.receiptItemList) {
							if (receipt_item_no_list.indexOf(ri.receipt_item_no) > -1) continue;

							receipt_item_no_list.push(ri.receipt_item_no);
							const added_obj = {
								type_code: type.receipt_type_code,
								display: type.receipt_type_code + ' ' + type.receipt_type_name,
								amount: ri.receipt_item_amount,
							};

							if (idx > -1) {
								const type_idx = date_summary[idx].type_list.findIndex(el => el.type_code === type.receipt_type_code);
								if (type_idx > -1) date_summary[idx].type_list[type_idx].amount += ri.receipt_item_amount;
								else date_summary[idx].type_list.push(added_obj);
							} else {
								date_summary.push({
									valid_receipt_date: receipt.valid_receipt_date,
									type_list: [added_obj],
								});
							}
						}
					}
				}
			}

			date_summary.forEach(ds => {
				ds.total = ds.type_list.reduce((prev, curr) => prev + curr.amount, 0);
				ds.type_list.sort((a, b) => {
					const a_code = a.type_code;
					const b_code = b.type_code;
					if (a_code < b_code) return -1;
					else if (a_code > b_code) return 1;
					else return 0;
				});
			});

			// valid_receipt_date로 sort
			date_summary.sort((a, b) => {
				const a_date = toDate(a.valid_receipt_date);
				const b_date = toDate(b.valid_receipt_date);
				if (a_date < b_date) return -1;
				else if (a_date > b_date) return 1;
				else return 0;
			});

			this.date_summary_data = date_summary;
		},
		makeDateSummaryExcelData() {
			// [{ valid_receipt_date: '...', total: ..., type_list: [{ type_code: '...', display: '...', amount: ... }, ...] }, ... ]
			const excel_data = [];
			this.date_summary_data.forEach(date => {
				excel_data.push({ type: date.valid_receipt_date, amount: null });
				date.type_list.forEach(type => {
					excel_data.push({ type: type.display, amount: type.amount });
				});
				excel_data.push({ type: 'Sub Total', amount: date.total });
			});
			excel_data.push({ type: 'Grand Total', amount: this.grandTotal });

			this.date_summary_excel_data = excel_data;
		},
		async changeTable(summary_type) {
			this.$store.commit('setLoading', true);

			const controll_spinner = () => {
				return new Promise(resolve => {
					setTimeout(() => {
						let unchecked = null;
						if (summary_type === 'BILLTO') {
							this.is_date_summary = false;
							this.is_summary = !this.is_summary;
							unchecked = this.$refs.summary_date;
						} else {
							this.is_summary = false;
							this.is_date_summary = !this.is_date_summary;
							unchecked = this.$refs.summary_bill_to;
						}
						unchecked.checked = false;

						resolve();
					}, 500);
				});
			};

			await controll_spinner();
			this.$nextTick(() => this.$store.commit('setLoading', false));
		},
		async index() {
			const { data } = await apiIndex();
			this.salesGroups = data.salesGroupList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.receiptTypeList = data.receiptTypeList;
		},
		setPartner(partner) {
			this.bill_to_code = partner.code;
		},
		reset() {
			this.sales_group_code = '';
			this.country = '';
			this.state = '';
			this.bill_to_code = '';
			this.receipt_type = '';
			this.sort_key = 'bill_to';
			this.sort_direction = 'ASC';
			this.from_date = today();
			this.to_date = today();
			this.bounced = false;
			this.receipt_type_exclude_yn = false;
			this.valid_only = true;
			this.is_summary = false;
			this.is_date_summary = false;
		},
		excel() {
			if (this.is_date_summary) {
				exportReceiptTypeDateSummaryDataExcel(this.date_summary_excel_data, 'ReceiptStatusByType_Date_Summary');
			} else if (this.is_summary) {
				exportReceiptTypeSummaryDataExcel(this.bill_to_summary_data, 'ReceiptStatusByType_BillTo_Summary');
			} else {
				exportReceiptTypeDataExcel(this.excel_data, 'ReceiptStatusByType');
			}
		},
		sort(sort_key) {
			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectData();
		},
	},
	computed: {
		grandTotal: function() {
			let total = 0;
			this.root.forEach(function(value) {
				total += value.total_amount;
			});
			return total;
		},
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
		viewReceiptRemark() {
			return this.company_id === 'hairplus' && this.user && this.user.view_receipt_remark;
		},
	},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_receiptType');
		this.$store.commit('setSubTitle', 'Report -> Receipt Status By Receipt Type');
		this.index();
	},
};
</script>

<style scoped>
.remark-table tbody th {
	padding: 2px 5px;
	font-size: 12px;
	color: #222;
	text-align: center;
	font-weight: bold;
	white-space: nowrap;
	border: 1px solid lightgray;
}

.remark-table tbody td {
	padding: 2px 5px;
	white-space: nowrap;
	border: 1px solid lightgray;
}
</style>
